import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import "../../styles/ChangePassword.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const ChangePassword = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [buttonClicked, setButtonClicked] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);


  const handleChangePassword = async () => {
    if (currentPassword.length < 8) {
      setError("Current password must be at least 8 characters long.");
      return;
    }
    if (newPassword.length < 8) {
      setError("New password must be at least 8 characters long.");
      return;
    }
    if (newPassword === currentPassword) {
      setError("New password must be different from the current password.");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    setError('');
    setButtonClicked(true);

    const config = {
      url: "/auth/changepassword",
      method: "post",
      data: { currentPassword, password: newPassword, userId: authState.user._id },
      headers: { Authorization: authState.token }
    };

    fetchData(config)
      .then(response => {
        if (response.data.status) {
          setSuccess(true);
          setMessage("Password Changed Successfully! Please login again.");
        } else {
          setMessage("Password not changed! Please try again.");
        }
      })
      .catch(error => {
        console.error('Error changing password:', error);
        setMessage("Error changing password. Please try again.");
      });
  };

  const toggleCurrentPasswordVisibility = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };

  const toggleNewPasswordVisibility = () => {
      setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmNewPasswordVisibility = () => {
      setShowConfirmNewPassword(!showConfirmNewPassword);
  };

  const handleBackClicked = async () => {
    navigate(-1);
  }

  return (
      <div className="min-h-full py-8 bg-gradient-to-r from-gray-500 via-gray-600 to-gray-700 mt-8">
        <h2 className='text-2xl font-bold text-white text-center mb-6'>Change Password</h2>
        <div className="px-4 flex items-center justify-center">
          <div className="flex flex-col justify-center">
            <div className='flex flex-row items-center relative mb-4'>
                  <label className="text-white  mb-2 w-48">Current Password:</label>
                  <div className="relative w-full" style={{ width: '310px' }}>
                      <input
                          type={showCurrentPassword ? 'text' : 'password'}
                          className="h-10 input-field w-full py-2 px-4 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 pr-10"
                          value={currentPassword}
                          onChange={(e) => setCurrentPassword(e.target.value)}
                          placeholder="Enter current password"
                          style={{ width: '400px' }}
                      />
                      <div
                          className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer text-white"
                          onClick={toggleCurrentPasswordVisibility}
                      >
                          <FontAwesomeIcon
                              icon={showCurrentPassword ? faEyeSlash : faEye}
                              size="lg"
                          />
                      </div>
                  </div>
              </div>

              <div className='flex flex-row items-start relative mb-4'>
                  <label className="text-white mb-2 w-48">New Password:</label>
                  <div className="relative w-full" style={{ width: '310px' }}>
                      <input
                          type={showNewPassword ? 'text' : 'password'}
                          className="h-10 input-field w-full py-2 px-4 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 pr-10"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          placeholder="Enter new password"
                          style={{ width: '400px' }}
                      />
                      <div
                          className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer text-white"
                          onClick={toggleNewPasswordVisibility}
                      >
                          <FontAwesomeIcon
                              icon={showNewPassword ? faEyeSlash : faEye}
                              size="lg"
                          />
                      </div>
                  </div>
              </div>

              <div className='flex flex-row items-start relative'>
                  <label className="text-white w-48">Confirm New Password:</label>
                  <div className="relative w-full" style={{ width: '310px' }}>
                  <input
                      type={showConfirmNewPassword ? 'text' : 'password'}
                      className="h-10 input-field w-full py-2 px-4 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                      value={confirmNewPassword}
                      onChange={(e) => setConfirmNewPassword(e.target.value)}
                      placeholder="Confirm new password"
                      style={{ width: '400px' }}
                  />
                  <div
                      className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer text-white"
                      onClick={toggleConfirmNewPasswordVisibility}
                  >
                      <FontAwesomeIcon
                          icon={showConfirmNewPassword ? faEyeSlash : faEye}
                          size="lg"
                      />
                  </div>
                </div>
              </div>

            {message && <p className="text-green-400">{message}</p>}
            {error && <p className="text-red-500">{error}</p>}

            <div className='flex flex-row justify-center items-center'>
              <button
                className="w-40"
                onClick={handleChangePassword}
                disabled={loading}
              >
                Change Password
              </button>
              <button
                className="w-40 ml-4"
                onClick={handleBackClicked}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ChangePassword;
